//TODO: is there anyway to refactor those collections into one ?
export type ComparisonUpdateFieldType =
	| 'vehicleCategories'
	| 'keywords'
	| 'categories'
	| 'driveVariants'
	| 'tags'
	| 'requirements'
	| 'dateNewTypes'
	| 'dateNewRegistration'
	| 'comprehensive'
	| 'modelYear'
	| 'phaseIn'
	| 'phaseOut'
	| 'summary'
	| 'attachments'
	| 'keywordAssignments';

export const ComparisonUpdateAllPossibleFields = [
	'vehicleCategories',
	'keywords',
	'categories',
	'driveVariants',
	'tags',
	'requirements',
	'dateNewTypes',
	'dateNewRegistration',
	'comprehensive',
	'modelYear',
	'phaseIn',
	'phaseOut',
	'summary',
	'attachments',
	'keywordAssignments',
] as ComparisonUpdateFieldType[];

export type ComparisonUpdateFields = ComparisonUpdateFieldType[];
